<div style="width: 100%">
  <div style="padding-top: 10px; margin-left: auto; margin-right: auto;">
<!--    <mat-grid-list cols="1" >-->
<!--      <mat-grid-tile i18n-class="@@dir">-->
<!--        <mat-card style="background: rgba(59, 56, 87, 0.94); height: 100%; width: 100%;">-->
<!--          <mat-card-content>-->
<!--            <div style="padding: 30px;">-->
<!--              <h3 style="padding-top: 150px;" i18n="@@Setting your password.">Setting your password.</h3>-->
<!--              <p i18n="@@....">..................................................................................</p>-->
<!--              <h2 style="padding-top: 40px" i18n="@@Main Organization Name">Main Organization Name</h2>-->
<!--              <p i18n="@@START YOUR PROJECT TODAY">START YOUR PROJECT TODAY</p>-->
<!--            </div>-->
<!--          </mat-card-content>-->
<!--        </mat-card>-->
<!--      </mat-grid-tile>-->
<!--      <mat-grid-tile i18n-class="@@dir">-->
        <mat-card appearance="outlined" class="formCard">
          <h1 i18n="@@Resend Code">Resend Code</h1>
          <img src="/logo.png" class="intro-logo">
          <mat-card-content>
            <form style="padding-top: 85px; padding-bottom: 85px;">
              <mat-form-field appearance="outline" class="full-width">
                <input matInput i18n-placeholder="@@Email" placeholder="Email" id="signupEmail" required type="email" maxlength="100" [(ngModel)]="email" [ngModelOptions]="{standalone: true}">
                <mat-error *ngIf="errorMessage">{{ errorMessage }}</mat-error>
              </mat-form-field>
            </form>
          </mat-card-content>
          <mat-card-actions class="primaryAction">
            <button mat-raised-button color="primary" (click)="resendCode()" id="signupSubmit" type="submit" i18n="@@Resend Code">Resend Code</button>
          </mat-card-actions>
          <mat-card-actions class="secondaryAction">
            <button *ngIf="environment.allowUsersToSignThemSelvesUp" mat-button color="primary" [routerLink]="['/home/register']"><ng-container i18n="@@Register">Register</ng-container></button>
            <button mat-button color="primary" [routerLink]="['/home/login']"><ng-container i18n="@@Login">Login</ng-container></button>
          </mat-card-actions>
        </mat-card>
<!--      </mat-grid-tile>-->
<!--    </mat-grid-list>-->
  </div>
</div>
